import { AccountNote } from '@/redux/modules/billingManagement/accountNote/accountNote.types';
import { handleResponseV2, makePost } from '@/redux/api/helpers';

type PostAccountNoteParams = {
    authToken: string;
    deployment: string;
    description: string;
    houseId: number;
    name: string;
    private: boolean;
};

type PostAccountNoteResponse = {
    error: boolean;
    payload: AccountNote;
};

export const postAccountNote = ({ authToken, deployment, houseId, ...body }: PostAccountNoteParams) =>
    new Promise<PostAccountNoteResponse>((resolve, reject) => {
        const request = makePost({
            apiPath: `admin/house/${houseId}/billing/account-note`,
            authToken,
            deployment,
            path: '<PAYMENT-SERVER-API>',
        });
        request.send(body);
        request.end((err, response) =>
            handleResponseV2({
                err,
                reject,
                resolve,
                response,
            })
        );
    });
